import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
export function AboutPage({
  onBack
}: {
  onBack: () => void;
}) {
  return <div className="min-h-screen bg-white pt-28 pb-20" data-id="element-149">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        {/* Back link */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} onClick={onBack} className="flex items-center text-primary hover:text-primary-dark transition-colors mb-12 group" data-id="element-151">
          <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-152" />
          <span className="text-sm uppercase tracking-widest font-medium" data-id="element-153">
            Back to Home
          </span>
        </motion.button>

        {/* Page heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} data-id="element-154">
          <div className="w-16 h-1 bg-primary mb-8" data-id="element-155"></div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 uppercase tracking-tight mb-6" data-id="element-156">
            About Us
          </h1>
        </motion.div>

        {/* Bio content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mt-12" data-id="element-157">
          <div className="prose prose-lg max-w-none" data-id="element-158">
            <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-159">
              Scott Uhrig founded Whiterock Partners in 2003 after spending
              several years as a Partner with Connect &amp; Company, one of the
              preeminent high-tech executive search firms in Silicon Valley, and
              Principal at TMP Worldwide, the 3rd largest executive search firm
              in the U.S. in the late 1990s.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-160">
              Prior to becoming a recruiter, Scott was an Associate with
              McKinsey &amp; Company, a leading global consulting firm. Earlier
              in his career, Scott was a Manager at GTE/Verizon and a Senior
              Software Engineer with Honeywell Aerospace.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-161">
              Scott has a BS and MS in Computer Science from the University of
              South Florida and an MBA from the University of Texas. He
              completed his coursework toward a PhD in Computer Science while
              serving as a full-time Instructor of Computer Science at the
              University of South Florida.
            </p>
          </div>

          {/* Decorative divider */}
          <div className="mt-16 pt-12 border-t border-gray-200" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/3dSrKM3ghNM5VaqUnLUSSd/Whiterock_Partners.png" alt="Whiterock Partners" className="h-8" data-id="element-163" />
            <p className="text-gray-500 mt-3 text-sm" data-id="element-164">
              Boutique Retained Executive Search &middot; Founded 2003 &middot;
              Austin, Texas
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}